module.exports = __webpack_public_path__ + "h5/img/top6.cff47b1a.png";